import cp from 'class-propper';
import uuid from 'uuid/v4';
import _ from 'lodash';

class SchemaSet {
  constructor(definition) {
    if (Array.isArray(definition) || !definition) {
      this.asRoot(definition);
    } else {
      const { name, type } = definition;
      this.name = name;
      this.type = type;
    }
  }

  asRoot(elements) {
    this.type = 'collection';
    this.name = 'root';
    this.member('metadata').type = 'object';
    this.addMember('fields', new SchemaSet({ name: 'fields', type: 'object' }));
    if (Array.isArray(elements)) {
      elements.forEach((element) => {
        this.addMember(element, true);
      });
    }
  }

  member(name) {
    if (!this.members.has(name)) {
      this.members.set(name, new SchemaSet({ name, type: 'collection' }));
    }
    return this.members.get(name);
  }

  addMember(element, intoFields = false) {
    const { name, type } = element;
    if (!name) {
      console.log('adding bad element', element);
      return;
    }
    const ss = (element instanceof SchemaSet) ? element : new SchemaSet(element);
    ss.parent = this;

    if (name.includes(':')) {
      const [prefix, ...suffix] = name.split(':');
      const remainder = suffix.join(':');
      this.member(prefix).addMember({ name: remainder, type });
    } else {
      if (ss.type === 'object') {
        return;
      }
      if (_.get(ss, 'parent.name') === 'categories') {
        ss.type = 'binary';
      }
      if (intoFields) {
        this.member('fields').addMember(ss);
      } else {
        this.members.set(name, ss);
      }
    }
  }

  toJSON() {
    const out = {
      type: this.type, id: this.id, name: this.name, members: {},
    };
    this.members.forEach((value) => {
      out.members[value.name] = value.toJSON();
    });
    return out;
  }

  toString(withType) {
    let name = this.name;
    let parentName = _.get(this, 'parent.name');
    if (['metadata', 'fields'].includes(parentName)) {
      parentName = '';
    }
    if (parentName) {
      name = `${parentName}."${name}"`;
    }
    if (withType) {
      name = `${name} (${this.type})`;
    }
    return name;
  }
}

SchemaSet.parse = rows => new SchemaSet(rows);

cp(SchemaSet)
  .addProp('members', {
    defaultValue: () => new Map(),
  })
  .addProp('parent', {
    defaultValue: null,
  })
  .addProp('id', {
    defaultValue: uuid,
  })
  .addProp('type', {
    type: 'string',
    defaultValue: '',
  })
  .addProp('name', {
    type: 'string',
    defaultValue: '',
  })
  .addProp('canWhere', {
    type: 'boolean',
    defaultValue: true,
  })
  .addProp('canMatch', {
    type: 'boolean',
    defaultValue: true,
  })
  .addProp('canSelect', {
    type: 'boolean',
    defaultValue: true,
  })
  .addProp('canOrder', {
    type: 'boolean',
    defaultValue: true,
  });

export default SchemaSet;
